export const roleEndpoints = {
  list: '/roles',
  permissions: '/roles/permissions',
  create: '/roles',
  update: (id: string) => `/roles/${id}`,
} as const

export const ROLE_LIST_KEY = ['roleList'] as const
export const PERMISSION_LIST_KEY = ['permissionList'] as const

// Backend `features/role/enums` + `GeneralCrudErrors` kodları.
export const roleBackendErrors = {
  GENERAL_ERROR: 'Bir hata oluştu. Lütfen tekrar deneyin.',
  ROLE_NAME_EXISTS: 'Bu isimde bir rol zaten var.',
  ROLE_SYSTEM_IMMUTABLE: 'Sistem rolünün izinleri değiştirilemez.',
  ROLE_NOT_FOUND: 'Rol bulunamadı.',
} as const

export const roleSuccessMessages = {
  roleCreate: 'Rol başarıyla oluşturuldu!',
  roleEdit: 'Rol başarıyla güncellendi!',
} as const

// İzin sunum kataloğu (kalın başlık + açıklama). Bilgilig dashboard'daki yönetici
// detayı görünümüyle aynı biçim. Backend izin açıklaması (henüz boş) eklenince
// `permission.description` fallback olarak kullanılabilir.
export type TPermissionMeta = {
  label: string
  description: string
}

export const permissionMeta: Record<string, TPermissionMeta> = {
  'user.list': {
    label: 'Kullanıcı Listele',
    description:
      'Kullanıcı listesini görüntüleme yetkisi. Sistemdeki tüm kullanıcıları listeleyebilir.',
  },
  'user.create': {
    label: 'Kullanıcı Oluştur',
    description:
      'Kullanıcı oluşturma yetkisi. Sisteme yeni bir kullanıcı hesabı ekleyebilir.',
  },
  'user.update': {
    label: 'Kullanıcı Düzenle',
    description:
      'Kullanıcı düzenleme yetkisi. Mevcut kullanıcının aktifliğini ve rollerini güncelleyebilir.',
  },
  'user.delete': {
    label: 'Kullanıcı Sil',
    description:
      'Kullanıcı silme yetkisi. Sistemdeki bir kullanıcı hesabını kaldırabilir.',
  },
  'role.list': {
    label: 'Rol Listele',
    description:
      'Rol listesini görüntüleme yetkisi. Sistemdeki tüm rolleri listeleyebilir.',
  },
  'role.create': {
    label: 'Rol Oluştur',
    description: 'Rol oluşturma yetkisi. Yeni rol tanımlayıp izin atayabilir.',
  },
  'role.update': {
    label: 'Rol Düzenle',
    description:
      'Rol düzenleme yetkisi. Mevcut bir rolün bilgilerini ve izinlerini güncelleyebilir.',
  },
  'role.delete': {
    label: 'Rol Sil',
    description: 'Rol silme yetkisi. Sistemdeki bir rolü kaldırabilir.',
  },
  'category.list': {
    label: 'Kategori Listele',
    description:
      'Kategori listesini görüntüleme yetkisi. Bilgilig kategorilerini listeleyebilir (soru üretimi dropdown).',
  },
  'generation.list': {
    label: 'Soru Üretimi Listele',
    description:
      'Soru üretimi listesini görüntüleme yetkisi. Üretim gruplarını listeleyebilir.',
  },
  'generation.create': {
    label: 'Soru Üretimi Başlat',
    description:
      'Soru üretimi başlatma yetkisi. Yeni bir soru üretim işi oluşturabilir.',
  },
  'generation.review': {
    label: 'Soru Üretimi İncele',
    description:
      'Soru üretimi inceleme yetkisi. Üretilen soruları inceleyip onaylayabilir.',
  },
  'generation.delete': {
    label: 'Soru Üretimi Sil',
    description: 'Soru üretimi silme yetkisi. Bir üretim grubunu kaldırabilir.',
  },
  'generation.deliver': {
    label: "Soru Üretimi Bilgilig'e Aktar",
    description:
      "Onaylanan soruları Bilgilig'e aktarma yetkisi. Bir üretim grubunu Bilgilig soru havuzuna teslim edebilir.",
  },
  'periodic.list': {
    label: 'Periyodik Üretim Listele',
    description:
      'Periyodik üretim listesini görüntüleme yetkisi. Tüm periyotları listeleyebilir.',
  },
  'periodic.create': {
    label: 'Periyodik Üretim Oluştur',
    description:
      'Periyodik üretim oluşturma yetkisi. Taslaktan otomatik tekrarlayan üretim tanımlayabilir.',
  },
  'periodic.update': {
    label: 'Periyodik Üretim Düzenle',
    description:
      'Periyodik üretim düzenleme yetkisi. Periyodu güncelleyip aktif/pasif yapabilir.',
  },
  'periodic.delete': {
    label: 'Periyodik Üretim Sil',
    description: 'Periyodik üretim silme yetkisi. Bir periyodu kaldırabilir.',
  },
  'period.list': {
    label: 'Periyot Listele',
    description:
      'Periyot kataloğunu görüntüleme yetkisi. Tekrar aralığı tanımlarını listeleyebilir.',
  },
  'period.create': {
    label: 'Periyot Oluştur',
    description:
      'Periyot oluşturma yetkisi. Yeni bir tekrar aralığı (ör. yarım saatte bir) tanımlayabilir.',
  },
  'period.update': {
    label: 'Periyot Düzenle',
    description:
      'Periyot düzenleme yetkisi. Tekrar aralığını güncelleyip aktif/pasif yapabilir.',
  },
  'period.delete': {
    label: 'Periyot Sil',
    description:
      'Periyot silme yetkisi. Kullanımda olmayan bir tekrar aralığını kaldırabilir.',
  },
}
